module.exports = __webpack_public_path__ + "static/assets/2fabc16cc481942c78920e02b00e47a0.png";